import styled from 'styled-components';
import type { PtoVolumePosition } from '@shared/api';
import { NOT_DEFINED, systemDoubtText, volumeSystem } from './systems';
import { WARN_SIGN, Warn } from './systemsUi';

const Undefined = styled.span`
  color: ${({ theme }) => theme.colors.text.secondary};
`;

/** Подписи источника системы строки (`raw.system.source`) — в подсказке. */
const SOURCE: Record<string, string> = {
  own_pos: 'из графы «Поз.» строки',
  vor_ref: 'из графы «Ссылки на чертежи» ВОР («см. систему …»)',
  pos_heading: 'по строке-заголовку системы выше',
  group_heading: 'по заголовку группы',
  name_parens: 'из наименования («(В25, В26…)»)',
  ai_section: 'по разделу позиции ИИ (код есть в перечне систем)',
};

interface Props {
  position: PtoVolumePosition;
}

/** Графа «Система» (разделы ОВ, ВК, НВ, НК): метка как в РД («В1», «В25, В26»)
 *  или «не определена»; сомнение разметки — значок с подсказкой. */
export function SystemCell({ position: p }: Props) {
  const s = volumeSystem(p.raw);
  if (!s) return <Undefined>{NOT_DEFINED}</Undefined>;
  const source = s.source ? SOURCE[s.source] : undefined;
  const doubt = s.doubt ? systemDoubtText(s.doubt) : null;
  return (
    <>
      {s.code ? <span title={source}>{s.label}</span> : <Undefined>{NOT_DEFINED}</Undefined>}
      {doubt && (
        <Warn role="img" aria-label={`Сомнение: ${doubt}`} title={`Сомнение: ${doubt}`}>
          {WARN_SIGN}
        </Warn>
      )}
    </>
  );
}
